const NIFFLER_ADMIN_ROUTE_PREFIX = "/:lang/akihiko/niffler";

export const nifflerAdminRoutes = Object.freeze({
    panel: Object.freeze({
        path: NIFFLER_ADMIN_ROUTE_PREFIX,
        role: "Knight"
    }),
    leads: Object.freeze({
        path: `${NIFFLER_ADMIN_ROUTE_PREFIX}/leads`,
        role: "Knight"
    }),
    brands: Object.freeze({
        path: `${NIFFLER_ADMIN_ROUTE_PREFIX}/brands`,
        role: "Doer"
    }),
    sales: Object.freeze({
        path: `${NIFFLER_ADMIN_ROUTE_PREFIX}/sales`,
        role: "Doer"
    }),
    newLead: Object.freeze({
        path: `${NIFFLER_ADMIN_ROUTE_PREFIX}/new-lead`,
        role: "Knight"
    }),
    translations: Object.freeze({
        path: `${NIFFLER_ADMIN_ROUTE_PREFIX}/translations`,
        role: "Knight"
    }),
    accessDenied: Object.freeze({
        path: `${NIFFLER_ADMIN_ROUTE_PREFIX}/access-denied`
    })
});

export const nifflerLeadsRoute = nifflerAdminRoutes.leads;

const read_route_language = (language = "en") => {
    return `${language || "en"}`.trim().replace(/^\/+|\/+$/g, "") || "en";
};

/**
 * Reads a canonical Niffler admin path, optionally with a nested page.
 */
export const read_niffler_admin_path = (language = "en", nestedPath = "") => {
    const routeLanguage = read_route_language(language);
    const routeSuffix = `${nestedPath || ""}`.trim().replace(/^\/+|\/+$/g, "");
    const basePath = NIFFLER_ADMIN_ROUTE_PREFIX.replace(":lang", routeLanguage);

    return routeSuffix ? `${basePath}/${routeSuffix}` : basePath;
};

/**
 * Reads the canonical protected admin path for the Niffler Leads page.
 */
export const read_niffler_leads_path = (language = "en") => {
    return read_niffler_admin_path(language, "leads");
};
